import {DG_Format_Money} from "../../../../format/money";

export const getMoneyUnit = (itemsCurrent, itemsSame) => {
    let max = Math.max(...itemsCurrent.map(item => item));

    if (itemsSame != null){
        const maxSame = Math.max(...itemsSame.map(item => item));
        if (Number(maxSame) > Number(max)){
            max = maxSame
        }
    }

    return Math.abs(Number(max)) >= 1.0e+9
        ? "Tỷ VNĐ"
        // Six Zeroes for Millions
        : Math.abs(Number(max)) >= 1.0e+6
            ? "Triệu VNĐ"
            // Three Zeroes for Thousands
            : "VNĐ"
}
export const getWeightUnit = (itemsCurrent, itemsSame) => {
    let max = Math.max(...itemsCurrent.map(item => item));

    if (itemsSame != null){
        const maxSame = Math.max(...itemsSame.map(item => item));
        if (Number(maxSame) > Number(max)){
            max = maxSame
        }
    }

    return Math.abs(Number(max)) >= 1000
        ? "Tấn" : "Kg"
}

export const getCurrencyUnit = (type, itemsCurrent, itemsSame) => {

    switch (type){
        case "bill":
            return "Phiếu"
        case "netWeight":
            return getWeightUnit(itemsCurrent, itemsSame)
        case "revenue":
            return getMoneyUnit(itemsCurrent, itemsSame)
        default:
            return type
    }
}

export const getRateCurrencyMoney = (itemsCurrent, itemsSame) => {
    let max = Math.max(...itemsCurrent.map(item => item));

    if (itemsSame != null){
        const maxSame = Math.max(...itemsSame.map(item => item));
        if (Number(maxSame) > Number(max)){
            max = maxSame
        }
    }

    return Math.abs(Number(max)) >= 1.0e+9

        ? 1.0e+9
        // Six Zeroes for Millions
        : Math.abs(Number(max)) >= 1.0e+6

            ? 1.0e+6
            // Three Zeroes for Thousands
            : 1
}

export const getRateCurrencyWeight = (itemsCurrent, itemsSame) => {
    let max = Math.max(...itemsCurrent.map(item => item));

    if (itemsSame != null){
        const maxSame = Math.max(...itemsSame.map(item => item));
        if (Number(maxSame) > Number(max)){
            max = maxSame
        }
    }

    return Math.abs(Number(max)) >= 1000
        ? 1000 : 1
}
export const getRateCurrency = (type, itemsCurrent, itemsSame) => {

    switch (type){
        case "netWeight":
            return getRateCurrencyWeight(itemsCurrent, itemsSame)
        case "revenue":
            return getRateCurrencyMoney(itemsCurrent, itemsSame)
        default:
            return 1
    }
}

export const convertMoney = (money) => {
    // Nine Zeroes for Billions
    return Math.abs(Number(money)) >= 1.0e+9
        ? (Number(money) / 1.0e+9).toFixed(2) + " tỷ VNĐ"
        // Six Zeroes for Millions
        : Math.abs(Number(money)) >= 1.0e+6
            ? (Number(money) / 1.0e+6).toFixed(2) + " triệu VNĐ"
            // Three Zeroes for Thousands
            : DG_Format_Money(money) + " VNĐ"
}
export const convertWeight = (weight) => {
    return Math.abs(Number(weight)) >= 1000
        ? (Number(weight) / 1000) + " tấn"
        : (Number(weight)) + " kg"
}
export const convertBill = (bill) => {
    return bill + " Phiếu"
}

export const convertTooltip = (type, value) => {

    switch (type){
        case "bill":
            return convertBill(value)
        case "netWeight":
            return convertWeight(value)
        case "revenue":
            return convertMoney(value)
        default:
            return ""
    }
}
